import Header from "../../shared/FanHeader/header";
import Footer from "../../shared/footer/footer";
import DashBoardComponentFan from "../../components/fan/fanDashboard";

const FanDashboard = () => {
	return (
		<div>
			<Header />
			<DashBoardComponentFan />
			<Footer />
		</div>
	);
};

export default FanDashboard;
